export default {
  status: {
    all: 'Todos',
    notEmitted: 'Sin emitir',
    pending: 'Pendiente de emisión',
    error: 'Error de emisión'
  }
}
